import { render, staticRenderFns } from "./MyApprovals.vue?vue&type=template&id=61ef59f2&scoped=true&"
import script from "./MyApprovals.vue?vue&type=script&lang=js&"
export * from "./MyApprovals.vue?vue&type=script&lang=js&"
import style0 from "./MyApprovals.vue?vue&type=style&index=0&id=61ef59f2&lang=scss&scoped=true&"
import style1 from "./MyApprovals.vue?vue&type=style&index=1&id=61ef59f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ef59f2",
  null
  
)

export default component.exports